module.exports = __webpack_public_path__ + "static/media/pressM.e68991d4.jpg";